/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:24 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: index.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/resources/layout/index.js
 */

// import Vue from 'vue/types'
import DefaultLayout from './default-layout'
import MasterLayout from './master-layout'
import NewsLayout from './news-layout'
import QuizLayout from './quiz-layout'

/*Vue.component('default-layout', DefaultLayout)
Vue.component('master-layout', MasterLayout)
Vue.component('news-layout', NewsLayout)
Vue.component('quiz-layout', QuizLayout)*/


export {DefaultLayout, MasterLayout, NewsLayout, QuizLayout}
